import React from "react";
import {longColour, shortColour} from "../../../../style/styleConsts";
import {hasNoVolume} from "../volumeCalculator";

export const SentimentChart = (props) => {
    const percentLong = props.percentageLong * 100;
    const percentShort = 100 - percentLong;

    const isFullyLongOrShort = percentLong === 0 || percentLong === 100;
    return <div style={{display: "flex", width: 100}}>
        {hasNoVolume(props) ? null : <div className="t-short-sentiment" style={{
            transition:      "width 0.3s",
            opacity:         0.5,
            backgroundColor: shortColour,
            height:          10,
            width:           percentShort + "%"
        }}/>}
        {hasNoVolume(props) ? null : <div className="t-long-sentiment" style={{
            transition:      "width 0.3s",
            marginLeft:      isFullyLongOrShort ? 0 : 2,
            opacity:         0.5,
            backgroundColor: longColour,
            height:          10,
            width:           percentLong + "%"
        }}/>}
    </div>
};